import React, { useEffect, useRef, useState, useMemo } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import { Group, Menu, MenuDropdown, Radio } from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { ReactComponent as DateIcon } from "../../../../../../assets/fi-rr-calendar.svg";
import CustomButton from "../../../../../../components/CustomButton";
import "../../../../../../components/customDate/customDate.css";
import { CountryDropdown } from "react-country-region-selector";
import "../../../../../../components/customSelect/customSelect.css";
import { ReactComponent as SelectIcon } from "../../../../../../assets/fi-rr-angle-small-down.svg";
import { Col, Row, Button } from "reactstrap";
import { ReactComponent as VectorIcon } from "../../../../../../assets/Vector.svg";
import { useForm, Controller } from "react-hook-form";
import CustomDOBPicker from "../../../../../../components/CustomDOBPicker";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

const TravelerInformation = ({
  setStepone,
  onSubmit,
  familyMembers,
  handleInputChange,
  handleTicketNumberChange,
  removeFamilyMember,
  isOpen,
  setIsOpen,
  setMobile,
  country1,
  setcountry,
  countryValid,
  setCountryValid,
  handleInputBlur,
  handleAddressInputChange,
  setTicket,
  setFamilyMembers,
  optionsList,
  claimData,
  isOpenList,
  setIsOpenList,
  position,
  isAddressDropdownOpen,
  setIsAddressDropdownOpen,
  handleClickAddressDropdown,
  setPdfBlob,
  pdfBlob,
  signatureCaptured,
  setSignatureCaptured,
  setIsAgreementChecked,
  clearPoaAndAgreement
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    getValues,
    reset,
    control,
    watch,
  } = useForm({
    mode: "onChange",
  });

  const [dateValue, setdateValue] = useState(null);

  const [isDisabledAddress, setDisableAddress] = useState(true)

  const formValues = watch();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // 🔥 Runs ONLY when form changes
    clearPoaAndAgreement();

  }, [formValues]);

  console.log("Family Memebrs ========== > ", familyMembers)

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "26px",
      backgroundColor: "#e8eef7",
      borderColor: state.isFocused ? " #e8eef7" : "#e8eef7",
      // boxShadow: state.isFocused ? "0 0 0 1px #1976d2" : "none",
      "&:hover": {
        borderColor: "#e8eef7",
      },
      padding: "8px 14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888",
      fontSize: "16px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      marginTop: "4px",
      zIndex: 9999, // fixes dropdown hiding behind other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#e3f2fd" : "white",
      color: "#333",
      padding: "10px",
      cursor: "pointer",
    }),
  };


  useEffect(() => {
    console.log(familyMembers.length)
    const num_of_passenger = familyMembers.length + 1 ?? 1;
    setValue('num_of_passenger', num_of_passenger, { shouldValidate: true })
  }, [familyMembers])

  // helper from earlier (parseAddressComponents) assumed present




  // const onPlaceSelect_JS = (val) => {
  //   if (!val) {
  //     setValue("city", "",{
  //       shouldValidate: true,
  //       shouldDirty: true,
  //       shouldTouch:true

  //       });
  //     setValue("state", "",{
  //       shouldValidate: true,
  //       shouldDirty: true,
  //       shouldTouch:true

  //       });
  //     setValue("postal_code", "",{
  //       shouldValidate: true,
  //       shouldDirty: true,
  //       shouldTouch:true

  //       });
  //     // setValue("country", "");
  //     // field.onChange("");
  //     return;
  //   }

  //   // react-google-places-autocomplete sometimes returns val.value as an object.
  //   // Try to get placeId safely:
  //   let placeId = typeof val.value === "string" ? val.value : (val.value?.place_id || val.value?.placeId);

  //   // fallback: some versions return val?.place_id or val?.value?.place_id
  //   if (!placeId && val?.place_id) {
  //     placeId = val.place_id;
  //   }

  //   // update display string
  //   const address = val.label || (val.description || "");
  //   // field.onChange(address);
  //   setValue("address", address, { shouldValidate: true ,shouldDirty:true,shouldTouch:true});

  //   if (!window.google || !placeId) {
  //     // if google script isn't loaded, fallback to server proxy option below
  //     console.warn("Google maps script not loaded or missing placeId — fallback to server.");
  //     return;
  //   }

  //   const ps = new window.google.maps.places.PlacesService(document.createElement("div"));
  //   ps.getDetails({ placeId, fields: ["address_component", "formatted_address"] }, (place, status) => {
  //     if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
  //       const parsed = parseAddressComponents(place.address_components || []);
  //       setValue("city", parsed?.city,{
  //         shouldValidate: true,
  //         shouldDirty: true,
  //         shouldTouch:true

  //       });
  //       setValue("state", parsed?.state,{
  //         shouldValidate: true,
  //         shouldDirty: true,
  //         shouldTouch:true

  //       });
  //       setValue("postal_code", parsed?.postalCode,{
  //         shouldValidate: true,
  //         shouldDirty: true,
  //         shouldTouch:true

  //       });
  //       // setValue("country", parsed.country);
  //       setcountry(parsed?.country)
  //       setValue("address", place?.formatted_address || address,{
  //         shouldValidate: true,
  //         shouldDirty: true,
  //         shouldTouch:true

  //       });
  //     } else {
  //       console.error("getDetails failed:", status);
  //     }
  //   });
  // };


  //   // helper - returns object { city, state, postalCode, country }
  // const parseAddressComponents = (components = []) => {
  //   const result = { city: "", state: "", postalCode: "", country: "" };

  //   components.forEach((c) => {
  //     if (c.types.includes("locality")) {
  //       result.city = c.long_name;
  //     }
  //     // sometimes city is in sublocality_level_1 or administrative_area_level_2
  //     if (!result.city && c.types.includes("sublocality_level_1")) {
  //       result.city = c.long_name;
  //     }
  //     if (!result.city && c.types.includes("administrative_area_level_2")) {
  //       result.city = c.long_name;
  //     }

  //     if (c.types.includes("administrative_area_level_1")) {
  //       result.state = c.long_name;
  //     }
  //     if (c.types.includes("postal_code")) {
  //       result.postalCode = c.long_name;
  //     }
  //     if (c.types.includes("country")) {
  //       result.country = c.long_name; // or c.short_name for "IN"
  //     }
  //   });

  //   return result;
  //   };
















  useEffect(() => {
    const loadInitialData = async () => {
      // Check if claimData exists and has actual values (not empty object)
      if (claimData && Object.keys(claimData).length > 0) {
        console.log("Loading from API data ----->", claimData);

        const defaultValues = {
          contact_no: claimData.contact_no || "",
          num_of_passenger: claimData.num_of_passenger || "",
          first_name: claimData.first_name || "",
          last_name: claimData.last_name || "",
          date_of_birth: claimData.date_of_birth || "",
          email_id: claimData.email_id || "",
          unit: claimData.unit || "",
          passport_number: claimData.passport_number || "",
          state: claimData.state || "",
          city: claimData.city || "",
          postal_code: claimData.postal_code || "",
          address: claimData.address || "",
          tickets: claimData.tickets || "",
          airline_res_no: claimData.airline_res_no || "",
        };
        reset(defaultValues);
        if (claimData.country) setcountry(claimData.country);
      }
      // Fallback to localStorage if claimData is empty or doesn't exist
      else {
        console.log("Falling back to localStorage ----->");
        const savedData = localStorage.getItem("travelerInformationData");
        if (savedData) {
          try {
            const parsedData = JSON.parse(savedData);
            if (parsedData.formValues) {
              reset(parsedData.formValues);
            }

            if (parsedData.familyMembers) {
              setFamilyMembers(parsedData.familyMembers)
            }
            if (parsedData.country1) {
              setcountry(parsedData.country1);
            }
          } catch (error) {
            console.error("Error parsing localStorage data:", error);
          }
        }
      }
    };

    loadInitialData();
  }, [claimData]); // Now depends on claimData to detect changes

  // 2. Sync family members with form
  useEffect(() => {
    setValue("sub_claims", [...familyMembers]);
  }, [familyMembers]);

  const [dropdownAbove, setDropdownAbove] = useState(false);

  const inputRef = useRef(null);
  const wrapperRef = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (!wrapperRef.current.contains(e.target)) {
  //       setIsAddressDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  // ✅ Adjust dropdown direction
  const adjustDropdownPosition = () => {
    const rect = inputRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const dropdownHeight = 150;

    setDropdownAbove(
      spaceBelow < dropdownHeight && spaceAbove > dropdownHeight
    );
  };

  const validateDateFormat = (value) => {
    const ddmmyyyy = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
    // const yyyymmdd = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

    if (ddmmyyyy.test(value)) {
      return true;
    }

    return "Date must be in mm-dd-yyyy format";
  };

  // 3. Persist all data to localStorage
  useEffect(() => {
    const saveData = () => {
      const dataToSave = {
        formValues: getValues(),
        country1,
        familyMembers,
      };
      localStorage.setItem(
        "travelerInformationData",
        JSON.stringify(dataToSave)
      );
    };

    // clearPoaAndAgreement()

    // Debounce the save to prevent excessive writes
    const debounceTimer = setTimeout(saveData, 300);
    return () => clearTimeout(debounceTimer);
  }, [formValues, familyMembers, getValues]);







  const parseAddressComponents = (components = []) => {
    const result = { city: "", state: "", postalCode: "", country: "" };

    components.forEach((c) => {
      if (c.types.includes("locality")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("sublocality_level_1")) {
        result.city = c.long_name;
      }
      if (!result.city && c.types.includes("administrative_area_level_2")) {
        result.city = c.long_name;
      }

      if (c.types.includes("administrative_area_level_1")) {
        result.state = c.long_name;
      }
      if (c.types.includes("postal_code")) {
        result.postalCode = c.long_name;
      }
      if (c.types.includes("country")) {
        result.country = c.long_name;
      }
    });

    return result;
  };

  // Helper: build only street-level address (exclude locality/admin/postal/country)
  const buildStreetAddress = (components = [], placeName = "") => {
    const keepTypes = new Set([
      "street_number",
      "route",
      "subpremise",
      "premise",
      "sublocality_level_1",
      "sublocality",
      "neighborhood",
      "establishment",
      "natural_feature",
      "airport",
    ]);

    const excludeTypes = new Set([
      "locality",
      "administrative_area_level_1",
      "administrative_area_level_2",
      "administrative_area_level_3",
      "postal_code",
      "country",
    ]);

    // First strict pass: keep components that contain at least one keepTypes and do not contain any exclude types
    const streetParts = components
      .filter((c) => {
        if (c.types.some((t) => excludeTypes.has(t))) return false;
        return c.types.some((t) => keepTypes.has(t));
      })
      .map((c) => c.long_name);

    // If we have streetParts, attempt to join in a sensible order: street_number before route
    if (streetParts.length) {
      // Try to put street number before route
      const number = components.find((c) => c.types.includes("street_number"))?.long_name;
      const route = components.find((c) => c.types.includes("route"))?.long_name;
      if (number && route) return `${number} ${route}`;
      // otherwise return the joined streetParts (first 3 parts)
      return streetParts.slice(0, 3).join(", ");
    }

    // Loose fallback: exclude obvious admin/postal/country types and take first few parts
    const loose = components
      .filter((c) => !c.types.some((t) => excludeTypes.has(t)))
      .map((c) => c.long_name);

    if (loose.length) return loose.slice(0, 3).join(", ");

    // Use place's name (business or establishment) as last-resort
    if (placeName) return placeName;

    return "";
  };

  // Called when a place is selected from autocomplete
  const onPlaceSelect_JS = (val) => {


    if (!val) {
      // clear related fields
      setValue("city", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("state", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      setValue("postal_code", "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });

      return;
    }

    // val.value might be a placeId or an object containing place_id
    let placeId = typeof val.value === "string" ? val.value : (val.value?.place_id || val.value?.placeId);
    if (!placeId && val?.place_id) placeId = val.place_id;

    const addressLabel = val.label || val.description || "";

    // Save a temporary address label while we fetch details
    // setValue('address', addressLabel, { shouldValidate: true, shouldDirty: true, shouldTouch: true });

    if (!window.google || !placeId) {
      // Google script not loaded (or not available) — keep the label but we can't refine components
      console.warn("Google script not loaded or missing placeId — cannot get address components.");
      return;
    }

    const ps = new window.google.maps.places.PlacesService(document.createElement("div"));

    ps.getDetails({ placeId, fields: ["address_components", "formatted_address", "name"] }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
        const parsed = parseAddressComponents(place.address_components || []);

        // keep other fields if you still want them stored in the form
        setValue("city", parsed?.city || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("state", parsed?.state || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setValue("postal_code", parsed?.postalCode || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
        setcountry(parsed?.country || "");

        // Build street-only address
        let streetAddress = buildStreetAddress(place.address_components || [], place.name || "");

        // If still empty, fallback to taking the first part(s) of formatted_address
        if (!streetAddress) {
          if (place.formatted_address) {
            // Take first segment(s) before locality/admin; naive split by comma
            const parts = place.formatted_address.split(",").map((p) => p.trim()).filter(Boolean);
            // prefer the first part (street line) only
            if (parts.length) streetAddress = parts[0];
          }
        }

        // Final fallback: use the label from autocomplete
        if (!streetAddress) streetAddress = addressLabel;

        setValue('address', streetAddress || "", { shouldValidate: true, shouldDirty: true, shouldTouch: true });
      } else {
        console.error("getDetails failed:", status);
      }
    });
  };








  // Combined validation for main form and sub claims
  const isFormValid = useMemo(() => {
    const mainFormValid =
      formValues.first_name &&
      formValues.last_name &&
      formValues.date_of_birth &&
      formValues.contact_no &&
      formValues.email_id &&
      formValues.unit &&
      formValues.passport_number &&
      formValues.address &&
      formValues.tickets &&
      country1 &&
      formValues.num_of_passenger &&
      formValues.postal_code &&
      formValues.state &&
      formValues.city &&
      formValues.airline_res_no;

    const subClaimsValid =
      !familyMembers.length ||
      formValues.sub_claims?.every(
        (claim) =>
          claim?.first_name &&
          claim?.last_name &&
          claim?.date_of_birth &&
          claim?.country &&
          claim?.passport_number &&
          claim?.tickets &&
          claim?.airline_res_no
      );

    return mainFormValid && subClaimsValid;
  }, [formValues, familyMembers.length, country1]);

  // Update stepone based on form validity
  useEffect(() => {
    setStepone(isFormValid);
  }, [isFormValid, setStepone]);

  const handleFormSubmit = (data) => {
    console.log("Form data submitted123", data);
    setStepone(true);
    onSubmit(data); // Pass the form data to the parent component
  };

  const dateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMaxLength = (e) => {
    const inputVal = e.target.value;

    // Allow only numbers and max 3 digits
    if (/^\d{0,3}$/.test(inputVal)) {
      setValue("num_of_passenger", inputVal, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };
  return (
    <div className="stepper-container">
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        id="travel-information-form"
      >
        <div className="stepper-header-container">
          <h3 className="stepper-header" style={{ margin: 0 }}>
            Traveler information
          </h3>
        </div>
        <div>
          <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
            How many passengers are included in this claim?
          </h4>
          <h6 className="sub-header" style={{ marginBottom: "15px" }}>
            Each passenger may be eligible for separate compensation.
          </h6>
          <div className="grid-two">
            <div className="custom-input" style={{ width: "100%" }}>
              <label className="input-label">
                Number of passengers
                <span style={{ color: "#de8385" }}> *</span>
              </label>
              <Controller
                name="num_of_passenger"
                control={control}
                defaultValue={''}
                rules={{
                  required: "Number of passengers is required",
                  min: {
                    value: 1,
                    message: "Minimum value is 1",
                  },
                  max: {
                    value: 999,
                    message: "Maximum value is 999",
                  },
                }}
                render={({ field }) => (
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter number of passengers"
                    inputMode="numeric"
                    readOnly
                    onChange={handleMaxLength}
                    onKeyDown={(e) => {
                      if (
                        [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ].includes(e.key)
                      ) {
                        return;
                      }

                      // Block if not a digit
                      if (!/^[0-9]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    min={1}
                  />
                )}
              />
              {errors.num_of_passenger && (
                <p className="errormessage">
                  {errors.num_of_passenger.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
          <div className="file-a-claim">
            <h4
              className="stepper-sub-header"
              style={{ marginBottom: "15px", marginTop: "30px" }}
            >
              First traveler details
            </h4>
            <h2
              className="stepper-sub-sub-header"
              style={{ marginBottom: "15px" }}
            >
              Personal details
            </h2>
            <div className="grid-two">
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  First name (as on ticket)
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="first_name"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "First Name is Required",
                    // pattern: {
                    //   value: /^[A-Za-z]+$/,
                    //   message: "First Name should contain only alphabets",
                    // },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter your first name"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/[^A-Za-z ]/g, "")  // allow only letters and spaces
                        // replace multiple spaces with a single space

                        field.onChange(value);
                      }}
                    />
                  )}
                />
                {errors.first_name && (
                  <p className="errormessage">{errors.first_name.message}</p>
                )}
              </div>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Last name (as on ticket)
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="last_name"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "Last Name is Required",
                    // pattern: {
                    //   value: /^[A-Za-z]+$/, // Only letters allowed
                    //   message: "Last Name should contain only alphabets",
                    // },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter your last name"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/[^A-Za-z]/g, "")
                        field.onChange(value);
                      }}
                    />
                  )}
                />
                {errors.last_name && (
                  <p className="errormessage">{errors.last_name.message}</p>
                )}
              </div>
            </div>
            <div className="grid-two">

              <Controller
                name="date_of_birth"
                control={control}
                rules={{
                  required: "Date of Birth is Required",
                  validate: validateDateFormat,
                }}
                render={({ field }) => (
                  <CustomDOBPicker
                    value={field.value ?? ""}
                    onChange={field.onChange}
                    error={errors.date_of_birth?.message}
                  />
                )}
              />

              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Phone number
                  <span style={{ color: "#de8385" }}> *</span> <small>(10 digit)</small>
                </label>
                <Controller
                  name="contact_no"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "Mobile Number is required",
                    validate: (value) =>
                      (value.length === 10) ||
                      "Mobile Number must be exactly 10 digits",
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter your phone number"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                        field.onChange(value);
                        setMobile(value);
                      }}

                      maxLength={10}
                    />
                  )}
                />
                {errors.contact_no && (
                  <p className="errormessage">{errors.contact_no.message}</p>
                )}
              </div>
            </div>
            <div className="grid-two">
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Email address
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="email_id"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "Email Address is Required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email id address",
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter your email"
                      type="email_id"
                      onKeyDown={(e) => {
                        // allow navigation keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // allow letters, numbers, @, ., _, -
                        if (!/^[a-zA-Z0-9@._-]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                />
                {errors.email_id && (
                  <p className="errormessage">{errors.email_id.message}</p>
                )}
              </div>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Passport Number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="passport_number"
                  control={control}
                  defaultValue={''}
                  rules={{ required: "Passport Number is Required" }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Passport number"
                      type="text"
                    />
                  )}
                />
                {errors.passport_number && (
                  <p className="errormessage">
                    {errors.passport_number.message}
                  </p>
                )}
              </div>
            </div>

            <h2
              className="stepper-sub-sub-header"
              style={{ marginBottom: "15px", marginTop: "30px" }}
            >
              Home address
            </h2>
            <div className="grid-two">
              <div style={{ display: 'flex', gap: "10px" }} className="street-address-wrapper">
                <div className="custom-input" style={{ flex: 1 }}>

                  <label className="input-label">
                    Street address
                    <span style={{ color: "#de8385" }}> *</span>
                  </label>


                  {isDisabledAddress ? <Controller
                    name="address"
                    control={control}
                    defaultValue={''}

                    rules={{ required: "Home Address is Required" }}
                    render={({ field }) => {

                      // Provide `value` as an object { label, value } expected by react-select
                      const value = field.value ? { label: field.value, value: field.value } : null;
                      return (


                        <GooglePlacesAutocomplete
                          {...field}
                          apiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
                          selectProps={{
                            value,
                            placeholder: "Search address...",
                            onChange: (val) => {
                              // val is { label, value }
                              const addr = val ? val.label : "";
                              // update react-hook-form field
                              field.onChange(addr);
                              // also update any other form state if needed
                              setValue("address", addr, { shouldValidate: true });
                              onPlaceSelect_JS(val)
                              console.log(val)
                            },
                            styles: selectStyles
                          }}
                        />)
                    }} /> : <Controller
                    name="address"
                    control={control}
                    defaultValue={''}

                    rules={{ required: "Home Address is Required" }}
                    render={({ field }) => {

                      return <input
                        {...field}
                        className="input-box"
                        placeholder="Enter address"
                        type="text"
                      />
                    }} />}







                  {errors.address && (
                    <p className="errormessage">{errors.address.message}</p>
                  )}
                </div>

                <div className="custom-input unit-wrapper" >
                  <label className="input-label">
                    Unit
                    <span style={{ color: "#de8385" }}> *</span>
                  </label>
                  <Controller
                    name="unit"
                    control={control}
                    defaultValue={''}
                    rules={{ required: "Unit is Required" }}
                    render={({ field }) => (
                      <input
                        {...field}
                        className="input-box"
                        placeholder="Unit"
                        type="text"
                      />
                    )}
                  />
                  {errors.unit && (
                    <p className="errormessage">
                      {errors.unit.message}
                    </p>
                  )}
                </div>


              </div>


              {/* <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Street address
                  <span style={{ color: "#de8385" }}> *</span>
                </label>

                <Controller
                  name="address"
                  control={control}
                  rules={{ required: "Home Address is Required" }}
                  render={({ field }) => (
                    <div
                      ref={wrapperRef}
                      style={{ position: "relative", width: "100%" }}
                    >
                      <input
                        {...field}
                        className="input-box"
                        placeholder="Enter street address"
                        type="text"
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          handleAddressInputChange(e);
                        }}
                        onBlur={handleInputBlur}
                      />

                      {isAddressDropdownOpen && optionsList.length > 0 && (
                        <div
                          style={{
                            position: "absolute",
                            left: 0,
                            right: 0,
                            [dropdownAbove ? "bottom" : "top"]: "100%",
                            maxHeight: "250px",
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            borderTop: dropdownAbove
                              ? "1px solid #ccc"
                              : "none",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            overflowY: "auto",
                          }}
                        >
                          {optionsList.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                field.onChange(item?.label);
                                handleClickAddressDropdown(item?.label);
                              }}
                              style={{
                                padding: "10px",
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                              }}
                            >
                              {item.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                />

                {errors.address && (
                  <p className="errormessage">{errors.address.message}</p>
                )}
              </div> */}
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  City
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="city"
                  control={control}
                  defaultValue={''}

                  rules={{ required: "City is Required" }}
                  render={({ field }) => (
                    <input
                      {...field}
                      readOnly={isDisabledAddress}
                      className="input-box"
                      placeholder="Enter city name"
                      type="text"
                    />
                  )}
                />
                {errors.city && (
                  <p className="errormessage">{errors.city.message}</p>
                )}
              </div>
            </div>
            <div className="grid-two">
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  State/Region
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="state"
                  control={control}
                  defaultValue={''}

                  rules={{ required: "State/region is Required" }}
                  render={({ field }) => (
                    <input
                      {...field}
                      readOnly={isDisabledAddress}
                      className="input-box"
                      placeholder="Select state/region"
                      type="text"
                      onKeyDown={(e) => {
                        // allow navigation & editing keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                            " ",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // allow only letters
                        if (!/^[a-zA-Z]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                />
                {errors.state && (
                  <p className="errormessage">{errors.state.message}</p>
                )}
              </div>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  ZIP/Postal code
                  <span style={{ color: "#de8385" }}> *</span>
                </label>

                <Controller
                  name="postal_code"
                  control={control}
                  defaultValue={''}

                  rules={{ required: "Zipcode is Required" }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      readOnly={isDisabledAddress}
                      placeholder="Enter ZIP or postal code"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                        field.onChange(value);
                      }}
                      type="text"
                    />
                  )}
                />
                {errors.postal_code && (
                  <p className="errormessage">{errors.postal_code.message}</p>
                )}
              </div>
            </div>

            <div className="grid-two">
              <div className="custom-select" style={{ width: "100%" }}>
                <span className="select-label">
                  Country <span style={{ color: "#de8385" }}> *</span>
                </span>
                <div
                  className="select-box"
                  style={{
                    borderColor: "#E6F6FF",
                    backgroundColor: "#e8eef7",
                  }}
                >
                  <CountryDropdown
                    className="countrydropdown2 form-control underline-input"
                    id="tcountry"
                    disabled={isDisabledAddress}
                    defaultOptionLabel="- Select country -"
                    placeholder="Select Country"
                    value={country1}
                    onChange={(val) => {
                      setcountry(val);
                      setCountryValid(false);
                    }}
                    style={{
                      background: "none",
                      outline: "none",
                      border: "none",
                      boxShadow: "none",
                    }}
                  />
                  <VectorIcon />
                </div>
                {countryValid ? (
                  <p className="errormessage">Country is Required</p>
                ) : null}
              </div>

              <div className="custom-select">
                <label className="input-label">Can’t find your address?</label>
                <button onClick={() => setDisableAddress(false)} className="btn btn-manual" type="button">Enter Manually</button>
              </div>

            </div>
            <h2
              className="stepper-sub-sub-header"
              style={{ marginBottom: "15px", marginTop: "30px" }}
            >
              Flight details
            </h2>
            <div className="grid-two">
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Ticket number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="tickets"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "Ticket Number is required",
                    validate: (value) =>
                      value.length === 13 || "Ticket Number must be 13 digits",
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter ticket number"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                        field.onChange(value);
                        setTicket(value);
                      }}
                      maxLength={13}
                    />
                  )}
                />
                {errors.tickets && (
                  <p className="errormessage">{errors.tickets.message}</p>
                )}
              </div>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  Airline reservation Number
                  <span style={{ color: "#de8385" }}> *</span>
                </label>
                <Controller
                  name="airline_res_no"
                  control={control}
                  defaultValue={''}
                  rules={{
                    required: "Airline Reservation Number is required",
                    validate: (value) => {
                      if (!/^[a-zA-Z0-9]+$/.test(value)) {
                        return "Only letters and numbers are allowed";
                      }
                      if (value.length < 6) {
                        return "Minimum 6 characters required";
                      }
                      if (value.length > 10) {
                        return "Maximum 10 characters allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="input-box"
                      placeholder="Enter airline reservation number"
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                      }}
                      maxLength={13}
                    />
                  )}
                />
                {errors.airline_res_no && (
                  <p className="errormessage">
                    {errors.airline_res_no.message}
                  </p>
                )}
              </div>
            </div>
          </div>
          {familyMembers.length > 0 && <>
            <h2
              className="stepper-sub-sub-header"
              style={{ marginBottom: "-15px", marginTop: "15px" }}
            >
              Additional Traveler Details
            </h2>


            {familyMembers.map((member, index) => (
              <React.Fragment key={index} >

                <div className="col-12">
                  <h4
                    className="stepper-sub-header"
                    style={{ marginBottom: "15px", marginTop: "15px" }}
                  >
                    Traveler {index + 2}
                  </h4>
                  {/* First Name, Last Name, and Date Of Birth Fields */}
                  <div
                    className="grid-two"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        First name (as on ticket)
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].first_name`}
                        control={control}
                        defaultValue={''}
                        rules={{
                          required: "Full Name is Required",
                          // pattern: {
                          //   value: /^[A-Za-z]+$/, // Allows letters and spaces
                          //   message: "Name should contain only alphabets",
                          // },
                        }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter your first name"
                            type="text"
                            value={member.first_name ?? ""}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/[^A-Za-z ]/g, "")

                              // Update form state and local state
                              field.onChange(value);
                              handleInputChange(
                                { target: { value } },
                                index,
                                "first_name"
                              );
                            }}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.first_name && (
                        <p className="errormessage">
                          {errors.sub_claims[index].first_name.message}
                        </p>
                      )}
                    </div>
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Last Name (as on ticket)
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].last_name`}
                        control={control}
                        defaultValue={''}
                        rules={{
                          required: "Last Name is Required",
                          // pattern: {
                          //   value: /^[A-Za-z]+$/, // Only letters, no spaces
                          //   message:
                          //     "Last Name should contain only alphabets (no spaces)",
                          // },
                        }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter your last name"
                            type="text"
                            value={member.last_name ?? ''}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/[^A-Za-z]/g, "")

                              field.onChange(value);
                              handleInputChange(
                                { target: { value } },
                                index,
                                "last_name"
                              );
                            }}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.last_name && (
                        <p className="errormessage">
                          {errors.sub_claims[index].last_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className="grid-two"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    {/* <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Date Of Birth
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].date_of_birth`}
                        control={control}
                        rules={{ required: "Date of Birth is Required" }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter your Dob"
                            type="date"
                            value={member.date_of_birth}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              handleInputChange(e, index, "date_of_birth");
                            }}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.date_of_birth && (
                        <p className="errormessage">
                          {errors.sub_claims[index].date_of_birth.message}
                        </p>
                      )}
                    </div> */}
                    <div>
                      <Controller
                        name={`sub_claims[${index}].date_of_birth`}
                        control={control}
                        defaultValue={''}
                        rules={{
                          required: "Date of Birth is Required",
                          validate: validateDateFormat,
                        }}
                        render={({ field }) => (
                          <CustomDOBPicker
                            value={member.date_of_birth ?? ''}
                            onChange={(value) => {
                              field.onChange(value);
                              handleInputChange(
                                { target: { value } },
                                index,
                                "date_of_birth"
                              );
                            }}
                          />
                        )}
                      />

                      {errors.sub_claims?.[index]?.date_of_birth && (
                        <p className="errormessage">
                          {errors.sub_claims[index].date_of_birth.message}
                        </p>
                      )}
                    </div>

                    <div className="custom-select" style={{ width: "100%" }}>
                      <span className="select-label">
                        Country <span style={{ color: "#de8385" }}> *</span>
                      </span>
                      <div
                        className="select-box"
                        style={{
                          borderColor: "#E6F6FF",
                          backgroundColor: "#e8eef7",
                        }}
                      >
                        <Controller
                          name={`sub_claims[${index}].country`}
                          control={control}
                          defaultValue={''}
                          rules={{ required: "Country is Required" }}
                          render={({ field }) => (
                            <CountryDropdown
                              {...field}
                              className="countrydropdown2 form-control underline-input"
                              id="tcountry"
                              defaultOptionLabel="- Choose your Country -"
                              value={member.country ?? ''}
                              onChange={(val) => {
                                field.onChange(val);
                                handleInputChange(
                                  { target: { value: val } },
                                  index,
                                  "country"
                                );
                              }}
                              style={{
                                background: "none",
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                              }}
                            />
                          )}
                        />
                      </div>
                      {errors.sub_claims?.[index]?.country && (
                        <p className="errormessage">
                          {errors.sub_claims[index].country.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className="grid-two"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Passport Number
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].passport_number`}
                        control={control}
                        defaultValue={''}
                        rules={{ required: "Passport Number is Required" }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="A12345678"
                            type="text"
                            value={member.passport_number ?? ''}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              handleInputChange(e, index, "passport_number");
                            }}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.passport_number && (
                        <p className="errormessage">
                          {errors.sub_claims[index].passport_number.message}
                        </p>
                      )}
                    </div>
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Ticket Number
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].tickets`}
                        control={control}
                        defaultValue={''}
                        rules={{ required: "Ticket Number is Required" }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter Ticket Number"
                            type="text"
                            value={member.tickets ?? ''}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              handleTicketNumberChange(e, index);
                            }}
                            maxLength={13}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.tickets && (
                        <p className="errormessage">
                          {errors.sub_claims[index].tickets.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div
                    className="grid-two"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        Airline reservation Number
                        <span style={{ color: "#de8385" }}> *</span>
                      </label>
                      <Controller
                        name={`sub_claims[${index}].airline_res_no`}
                        control={control}
                        defaultValue={''}
                        rules={{
                          required: "Airline reservation Number is Required",
                        }}
                        render={({ field }) => (
                          <input
                            {...field}
                            className="input-box"
                            placeholder="Enter Airline reservation Number"
                            type="text"
                            value={member.airline_res_no ?? ''}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              handleInputChange(e, index, "airline_res_no");
                            }}
                            maxLength={13}
                          />
                        )}
                      />
                      {errors.sub_claims?.[index]?.airline_res_no && (
                        <p className="errormessage">
                          {errors.sub_claims[index].airline_res_no.message}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Remove Button */}
                  <div className="row mt-3">
                    <div className="col-md-2">
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => removeFamilyMember(index)}
                        style={{ marginTop: "30px" }}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))} </>}


        </div>
      </form>
    </div>
  );
};

export default TravelerInformation;
